(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1715],{

/***/ 44980:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download",
      function () {
        return __webpack_require__(67475);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 67475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_device_detect__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85518);




var DownloadPage = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var url = "https://anthu.vn" || 0;
    if (react_device_detect__WEBPACK_IMPORTED_MODULE_3__/* .isIOS */ .gn && "https://apps.apple.com/vn/app/anthu/id1613308085?l=vi") {
        url = "https://apps.apple.com/vn/app/anthu/id1613308085?l=vi";
    }
    if (react_device_detect__WEBPACK_IMPORTED_MODULE_3__/* .isAndroid */ .Dt && "https://play.google.com/store/apps/details?id=com.anthu.diamond") {
        url = "https://play.google.com/store/apps/details?id=com.anthu.diamond";
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        window.location.href = url;
    }, [
        url
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
        children: "Redirecting..."
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (DownloadPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5518,9774,2888,179], function() { return __webpack_exec__(44980); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);